export default __webpack_public_path__ + "static/impressum-166000ad5f46ac2aba9e6f741179c3d7.png";